import React, { useTransition } from 'react'
import 'react-slideshow-image/dist/styles.css'
import {Fade, fade, Slide} from 'react-slideshow-image'
import Slider1 from '../Assets/Mian-Slider/slider01.jpg'
import Slider2 from '../Assets/Mian-Slider/slider02.jpg'
import Slider3 from '../Assets/Mian-Slider/slider03.jpg'
import Slider4 from '../Assets/Mian-Slider/slider04.jpg'
import Slider5 from '../Assets/Mian-Slider/slider05.jpg'
import Slider6 from '../Assets/Mian-Slider/slider06.jpg'
import Slider7 from '../Assets/Mian-Slider/slider07.jpg'
import Slider8 from '../Assets/Mian-Slider/slider08.jpg'
import Slider9 from '../Assets/Mian-Slider/slider09.jpg'
import Slider10 from '../Assets/Mian-Slider/slider11.jpg'
import Slider11 from '../Assets/Mian-Slider/slider04.jpg'
import Slider12 from '../Assets/Mian-Slider/slider12.jpg'
import Slider13 from '../Assets/Mian-Slider/slider13.jpg'
import Slider14 from '../Assets/Mian-Slider/slider14.jpg'
import Slider15 from '../Assets/Mian-Slider/slider15.jpg'
import Slider16 from '../Assets/Mian-Slider/slider16.jpg'
import Slider17 from '../Assets/Mian-Slider/slider17.jpg'
import Slider18 from '../Assets/Mian-Slider/slider18.jpg'
import Slider19 from '../Assets/Mian-Slider/slider19.jpg'

const slideImages =[
   {
  url: Slider1
    },
   {
    url: Slider2
    },
   {
    url: Slider3
    },
    {
    url: Slider4
    },
    {
    url: Slider5
    },
    {
    url: Slider6
    },
    {
    url: Slider7
    },
    {
    url: Slider8
    },
    {
    url: Slider9
    },
    {
    url: Slider10
    },
    {
    url: Slider11
    },
    {
    url: Slider12
    },
    {
    url: Slider13
    },
    {
    url: Slider14
    },
    {
    url: Slider15
    },
    {
    url: Slider16
    },
    {
    url: Slider17
    },
    {
    url: Slider18
    },
    {
    url: Slider19
    },
]
const divStyle = {
display: 'flex',
alignItems: "center",
justifyContent: "center",
width: "100%",
height: "80vh",
backgroundSize: 'cover',

}

const NavImageSlider = () => {
  return (
    <div className='slide-contanoir'>
     <Slide duration={2500} >
      {
        slideImages.map((image, index)=> (
          <div key={index}>
            <div style={{...divStyle, backgroundImage:`url(${image.url})`}}>

            </div>
          </div>
        ))
      }
     </Slide>

      
    </div>
  )
}

export default NavImageSlider
